var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, h } from 'preact';
import * as SockJS from 'sockjs-client';
import * as Stomp from 'webstomp-client';
import Start from '../Start/Start';
import Dropdown from '../Dropdown/Dropdown';
import SrwrdsLogo from '../SrwrdsLogo/SrwrdsLogo';
import ProgressBar from '../ProgressBar/ProgressBar';
import WatchClickOutside from '../Dropdown/ClickOutside';
import { formatExpiresOnTime, dispatchGlobalEvent, getCookieAdapter, hermesLog, inContext, newLine, numberSeparator, sprintf, } from '../../services/UtilsTool';
import { LocaleLoader } from '../../services/LocaleLoader';
import './App.scss';
var language = 'en';
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.progressMouseEnter = false;
        _this.dropdownMouseEnter = false;
        _this.subscriptions = [];
        _this.tierComplete = null;
        _this.boostChange = null;
        _this.pointsUp = false;
        _this.initialWidgetData = false;
        _this.animationQueue = [];
        _this.prevLoggedIn = false;
        _this.isDropdownClosed = true;
        _this.loginIfNotSubscribedAndNotLoggedIn = function () {
            if (!_this.state.subscribed && !_this.prevLoggedIn) {
                _this.onRamLogin();
                _this.prevLoggedIn = true;
            }
        };
        /**
         * Handler for the RAM loggedOut event
         * We hide the widget and disconnect from the web socket server
         *
         * @memberOf App
         */
        _this.onRamLogout = function () {
            _this.setState({
                auth: false,
            });
            _this.disconnect();
        };
        /**
         * Constructs an animation queue and populates
         * the animation queue with the widget data.
         *
         * @param {*} data widgetData & converted locale data
         *
         * @memberOf App
         */
        _this.addToAnimationQueue = function (data) {
            _this.animationQueue.push(data);
            if (_this.animationQueue.length === 1) {
                _this.processAnimationQueue();
            }
        };
        /**
         * Processes the animation queue and sets the
         * widget with new values every n seconds.
         *
         * @memberOf App
         */
        _this.processAnimationQueue = function () {
            if (_this.animationQueue.length > 0) {
                _this.animationQueueTimer = setTimeout(function () {
                    var prevPoints = _this.state.currentPoints;
                    var firstItem = _this.animationQueue.shift();
                    var currentPoints = firstItem.widgetData.currentPoints;
                    var currentBoost = firstItem.widgetData.boostRemaining;
                    var prevBoost = _this.state.boostRemaining;
                    var tierEndPoints = _this.state.targetPoints;
                    _this.setWidgetData(firstItem);
                    _this.tierComplete =
                        currentPoints === tierEndPoints
                            ? true
                            : currentPoints === 0
                                ? false
                                : null;
                    _this.boostChange = currentBoost !== prevBoost ? true : false;
                    _this.pointsUp = prevPoints < currentPoints ? true : false;
                    _this.processAnimationQueue();
                }, App.ANIMATION_DELAY);
                _this.pointsUp = false;
            }
            else {
                _this.clearAnimationQueue();
            }
        };
        /**
         * Destroy the animationQueue timer
         *
         * @memberOf App
         */
        _this.clearAnimationQueue = function () {
            clearTimeout(_this.animationQueueTimer);
            _this.animationQueueTimer = null;
        };
        /**
         * Set the widget data
         *
         * @param {any} data widgetData values including time, tierUpTime & boost_on_string
         *
         * @memberOf App
         */
        _this.setWidgetData = function (data) {
            var _a = data.widgetData.cvlConfig, timezone = _a.timezone, expiresOn = _a.expiresOn;
            var translatedCurrentPoints = numberSeparator(data.widgetData.currentPoints, _this.state.formats.GROUP_SEP, _this.state.formats.DECIMAL_SEP);
            var translatedTargetPoints = numberSeparator(data.widgetData.targetPoints, _this.state.formats.GROUP_SEP, _this.state.formats.DECIMAL_SEP);
            var translatedNextChestPts = numberSeparator(data.widgetData.targetPoints - data.widgetData.currentPoints, _this.state.formats.GROUP_SEP, _this.state.formats.DECIMAL_SEP);
            var pluralisedChests = sprintf(data.widgetData.chestsCount === 1
                ? _this.state.locale.Open_Chest
                : _this.state.locale.Open_Chests, ['']);
            _this.setState({
                isCasino: inContext('CASINO'),
                isExpanded: inContext('RAM|MPA3|MPA3-TABLET|DETAILS'),
                needsLogo: inContext('RAM|MPA3'),
                isMobileCasino: inContext('CASINO-MOBILEWEB'),
                barOnly: inContext('BAR'),
                detailsOnly: inContext('DETAILS'),
                userOptedIn: data.widgetData.userOptedIn,
                optinNotificationActive: data.widgetData.optinNotificationActive,
                tierId: data.widgetData.tierId,
                boostRemaining: data.widgetData.boostRemaining,
                nextBoostTime: data.widgetData.nextBoostTime,
                currentPoints: data.widgetData.currentPoints,
                targetPoints: data.widgetData.targetPoints,
                chestsCount: data.widgetData.chestsCount,
                showTierUp: data.showTierUp,
                boostTime: data.boostTime,
                tierUpTime: data.tierUpTime,
                Boost_onX_N0_points: data.boost_on_string,
                Boost_on_slice: newLine(data.boost_on_string, ':'),
                N0_points: sprintf(_this.state.locale.N0_points, [
                    translatedCurrentPoints,
                    translatedTargetPoints,
                ]),
                N0_to_upgrade: sprintf(_this.state.locale.N0_to_upgrade, [
                    data.tierUpTime,
                ]),
                tierUpString: sprintf(_this.state.locale.N0_to_upgrade, ['']),
                Next_boostX_N0: data.boostTime && sprintf(_this.state.locale.Next_boostX_N0, [data.boostTime]),
                nextBoostString: sprintf(_this.state.locale.Next_boostX_N0, ['']),
                Open_Chest: pluralisedChests,
                Next_chestX_N0_points: sprintf(_this.state.locale.Next_chestX_N0_points, [
                    translatedNextChestPts,
                ]),
                More_info: _this.state.locale.More_info,
                Exchange: _this.state.locale.Exchange,
                Exchange_now: _this.state.locale.Exchange_now,
                Cancel: _this.state.locale.Cancel,
                Do_you_want_to_exchange_your_c_ELL: _this.state.locale.Do_you_want_to_exchange_your_c_ELL,
                Click_for_more_information: _this.state.locale.Click_for_more_information,
                Boosts_double_the_rate_at_whic_ELL: _this.state.locale.Boosts_double_the_rate_at_whic_ELL,
                To_win_a_ChestX_fill_your_prog_ELL: _this.state.locale.To_win_a_ChestX_fill_your_prog_ELL,
                Boost_on_for_next_N0_points: data.boost_on_string,
                Level_N0X_N1_N2_Chests_to_upgr_ELL: data.level_chest_upgrade,
                Win_N0_Chests_in_a_rolling_N1__ELL: data.win_chests_days,
                You_have_until_then_to_complet_ELL: data.widgetData.tierId === 1 ? _this.state.locale.You_have_until_then_to_complet_ELL_1 : _this.state.locale.You_have_until_then_to_complet_ELL,
                YouXve_completed_N0NN_of_your__ELL: data.you_have_completed,
                ExpiresX: _this.state.locale.ExpiresX,
                scaling: _this.liquidHeight(),
                pointsUp: false,
                tierChange: false,
                cvl2: data.widgetData.cvlConfig.cvl2,
                boostEnabled: data.widgetData.cvlConfig.boostEnabled,
                showTierDown: data.showTierDown,
                showTierDownExchange: data.widgetData.cvlConfig.showTierDownExchange,
                canExchange: data.widgetData.cvlConfig.canExchange,
                tierUpDays: data.widgetData.cvlConfig.tierUpDays,
                tierUpBars: data.widgetData.cvlConfig.tierUpBars,
                daysToExpire: data.widgetData.cvlConfig.daysToExpire,
                exchangePercent: data.widgetData.cvlConfig.exchangePercent,
                expiresOn: formatExpiresOnTime(expiresOn, timezone, language),
                recentBarCounter: data.widgetData.cvlConfig.recentBarCounter,
                timezone: data.widgetData.cvlConfig.timezone
            });
            _this.initialWidgetData = false;
        };
        _this.onProgressMouseEnter = function () {
            !_this.state.isCasino ? (_this.progressMouseEnter = true) : null;
        };
        _this.onProgressMouseDown = function () {
            _this.state.isCasino ? (_this.progressMouseEnter = true) : null;
        };
        _this.onProgressMouseLeave = function () {
            _this.progressMouseEnter = false;
            _this.dropdownMouseEnter ? _this.showDetails() : _this.hideDetails();
        };
        _this.onProgressMouseClick = function (data) {
            if (data === 'show') {
                _this.setState({ showDropdown: true, hideNudge: true });
            }
            else {
                _this.setState({ showDropdown: false, hideNudge: false });
            }
        };
        _this.onDropdownMouseEnter = function () {
            if (inContext('CASINO')) {
                _this.dropdownMouseEnter = true;
            }
            !_this.state.isCasino ? (_this.dropdownMouseEnter = true) : null;
        };
        _this.onDropdownMouseDown = function () {
            _this.state.isCasino ? (_this.dropdownMouseEnter = true) : null;
        };
        _this.onDropdownMouseLeave = function () {
            _this.dropdownMouseEnter = false;
            if (inContext('CASINO') && !_this.progressMouseEnter) {
                _this.hideDetails();
            }
            _this.progressMouseEnter ? _this.showDetails() : _this.hideDetails();
        };
        _this.onDropdownExpanded = function () {
            _this.isDropdownClosed = false;
        };
        _this.liquidHeight = function () {
            var parentHeight = 42;
            var liquidParent = document.querySelector('[stars-rewards=CASINO]');
            {
                liquidParent
                    ? liquidParent.offsetHeight * 0.0238 <= 1
                        ? (parentHeight = liquidParent.offsetHeight * 0.02176)
                        : (parentHeight = 1)
                    : (parentHeight = 1);
            }
            return parentHeight;
        };
        /**
         * Force update of a component on window resize.
         */
        _this.resizeChecker = function () {
            window.addEventListener('resize', resizeThrottler, false);
            var self = _this;
            var resizeTimeout;
            function resizeThrottler() {
                // ignore resize events as long as an actualResizeHandler execution is in the
                // queue
                if (!resizeTimeout) {
                    resizeTimeout = setTimeout(function () {
                        resizeTimeout = null;
                        actualResizeHandler();
                        // The actualResizeHandler will execute at a rate of 15fps
                    }, 66);
                }
            }
            function actualResizeHandler() {
                // handle the resize event
                // console.log('resizing');
                self.setState({
                    scaling: self.liquidHeight(),
                });
            }
        };
        /**
         * Set showDropdown & hideNudge state as true.
         * The dropdown and nudge will be shown on the widget.
         *
         * @memberOf App
         */
        _this.showDetails = function () {
            !_this.state.isCasino
                ? _this.setState({
                    showDropdown: true,
                    hideNudge: true,
                })
                : null;
        };
        _this.showDetailsDown = function () {
            _this.setState({
                showDropdown: true,
                hideNudge: true,
            });
        };
        /**
         * Set showDropdown & hideNudge state as false.
         * The dropdown and nudge will be hidden on the widget.
         *
         * @memberOf App
         */
        _this.hideDetails = function () {
            if (_this.state.isExpanded === true) {
                _this.showDetails;
            }
            else {
                _this.setState({
                    showDropdown: false,
                    hideNudge: false,
                });
            }
        };
        _this.exchangeAction = function () {
            if (_this.state.exchangeActionDisabled) {
                return;
            }
            // disable exchangeAction to avoid multiple button clicks
            _this.setState({ exchangeActionDisabled: true });
            var exchangeData = {
                id: 1,
                type: 'exchange'
            };
            if (_this.stompClient) {
                _this.stompClient.send(App.DESTINATION.API, JSON.stringify(exchangeData));
            }
        };
        _this.exchangeResponse = function (_a) {
            var id = _a.id, type = _a.type, success = _a.success;
            if (type === 'exchange') {
                if (success && _this.state.exchangeActionDisabled) {
                    dispatchGlobalEvent('srwrdsOpenChests');
                    _this.onDropdownMouseLeave();
                }
                _this.setState({ exchangeActionDisabled: false, hideExchangeView: true });
                // reset the exchange view
                setTimeout(function () {
                    _this.setState({ hideExchangeView: false });
                }, 1);
            }
        };
        var defaultState = {
            userOptedIn: false,
            optinNotificationActive: true,
            tierId: 1,
            boostRemaining: 0,
            nextBoostTime: {
                hours: 0,
                minutes: 0
            },
            currentPoints: 0,
            targetPoints: 0,
            chestsCount: null,
            showTierUp: null,
            tierUpEnd: '0h',
            auth: false,
            subscribed: false,
            N0_points: '',
            Boost_onX_N0_points: '',
            Boost_on_slice: '',
            Next_boostX_N0: '',
            N0_to_upgrade: '',
            Open_Chest: '',
            Next_chestX_N0_points: '',
            Start: 'Start',
            Join_Stars_Rewards: '',
            Time: '',
            More_info: '',
            Exchange: '',
            Exchange_now: '',
            Cancel: '',
            Do_you_want_to_exchange_your_c_ELL: '',
            Click_for_more_information: '',
            Boosts_double_the_rate_at_whic_ELL: '',
            To_win_a_ChestX_fill_your_prog_ELL: '',
            Boost_on_for_next_N0_points: '',
            Level_N0X_N1_N2_Chests_to_upgr_ELL: '',
            Win_N0_Chests_in_a_rolling_N1__ELL: '',
            You_have_until_then_to_complet_ELL: '',
            YouXve_completed_N0NN_of_your__ELL: '',
            ExpiresX: '',
            scaling: 1,
            sounds: false,
            height: null,
            goingToTierUp: false,
            goingToTierDown: false,
            exchangeActionDisabled: false,
            hideExchangeView: false,
            cvlConfig: {
                cvl2: false,
                boostEnabled: false,
                goingToTierUp: false,
                goingToTierDown: false,
                showTierDownExchange: false,
                canExchange: false,
                tierUpDays: 0,
                tierUpBars: 0,
                daysToExpire: 0,
                exchangePercent: 0,
                expiresOn: '0',
                recentBarCounter: 0,
                timezone: '',
            }
        };
        _this.state = defaultState;
        return _this;
    }
    /**
     * Invoked immeditaely after a component is mounted
     *
     * @memberOf App
     */
    App.prototype.componentDidMount = function () {
        var _this = this;
        // window.addEventListener(App.RAM_LOGIN_EVT, (e: Event) => this.visibilityCheck(), false);
        // PYR-54876 temporarily keeping both events
        window.addEventListener(App.RAM_INIT_EVT, function (e) { return _this.visibilityCheck(); }, false);
        window.addEventListener(App.RAM_LOGOUT_EVT, function (e) { return _this.onRamLogout(); }, false);
        window.addEventListener(App.RAM_SHOW_EVT, function (e) { return _this.loginCheck(); }, false);
        window.addEventListener(App.RAM_HIDE_EVT, this.onRamLogout, false);
        window.addEventListener(App.SOUNDS_EVT, function (e) { return _this.enableSounds(e); }, false);
        if (document.querySelector('[stars-rewards]')) {
            dispatchGlobalEvent('srwrdsReady', true);
            this.resizeChecker();
        }
    };
    /**
     * Invoked immediately before the component is unmounted and destroyed
     *
     * @memberOf App
     */
    App.prototype.componentWillUnmount = function () {
        var _this = this;
        // window.removeEventListener(App.RAM_LOGIN_EVT, (e: Event) => this.visibilityCheck(), false);
        // PYR-54876 temporarily keeping both events
        window.removeEventListener(App.RAM_INIT_EVT, function (e) { return _this.visibilityCheck(); }, false);
        window.removeEventListener(App.RAM_LOGOUT_EVT, function (e) { return _this.onRamLogout(); }, false);
        this.clearAnimationQueue();
        this.prevLoggedIn = false;
    };
    // Visibility flag check
    App.prototype.visibilityCheck = function () {
        window.addEventListener(App.RAM_SHOW_EVT, this.loginIfNotSubscribedAndNotLoggedIn, false);
    };
    App.prototype.loginCheck = function () {
        // window.addEventListener(App.RAM_LOGIN_EVT, this.loginIfNotSubscribedAndNotLoggedIn, false);
        // PYR-54876 temporarily keeping both events
        window.addEventListener(App.RAM_INIT_EVT, this.loginIfNotSubscribedAndNotLoggedIn, false);
    };
    /**
     * We attempt to connect and authenticate
     *
     * @memberOf App
     */
    App.prototype.initialize = function (retry) {
        var _this = this;
        // console.log('[WS Endpoint]', App.WS_ENDPOINT);
        var options = {
            protocols: [''],
            debug: false,
            binary: false,
            heartbeat: false,
        };
        this.stompClient = Stomp.over(new SockJS(App.WS_ENDPOINT), options);
        this.stompClient.connect(this.getAuthHeader(), function (frame) { return _this.onConnect(frame); }, function (frame) { return _this.onError(frame, retry); });
        this.initialWidgetData = true;
    };
    /**
     * Handler for the RAM loggedIn event
     * We load the language file
     *
     * @memberOf App
     */
    App.prototype.onRamLogin = function () {
        // console.log('[RAM login event detected]');
        var _this = this;
        language = getCookieAdapter('LANG') || 'en';
        LocaleLoader(language)
            .then(function (res) { return _this.onLocaleLoad(res); })
            .catch(function (err) {
            hermesLog('error', err, 'Missing i18n');
            LocaleLoader(App.DEFAULT_LANG).then(function (res) {
                return _this.onLocaleLoad(res);
            });
        });
    };
    App.prototype.enableSounds = function (play) {
        this.setState({
            sounds: play['detail'].soundOn,
        });
    };
    /**
     * Handler for when the locale module is loaded
     * We can initialize the app at this point
     *
     * @param {Locale} locale
     *
     * @memberOf App
     */
    App.prototype.onLocaleLoad = function (locale) {
        this.setState({
            locale: locale.text,
            formats: locale.angular.NUMBER_FORMATS,
        });
        this.initialize();
    };
    App.prototype.stripHours = function (hours, minutes) {
        var time = sprintf(this.state.locale.Time, [hours, minutes]);
        if (hours === 0) {
            var startIndex = time.indexOf(minutes);
            // console.log('``````````````````````````````````````````````', time, startIndex);
            time = time.substring(startIndex);
            if (minutes === 1) {
                time = '< ' + time;
            }
        }
        return time;
    };
    App.prototype.reconnect = function (retry) {
        var _this = this;
        // console.log('WS RECCONNECTION ATTEMPT');
        var defaultTime = 1000;
        if (retry !== undefined && retry < 64) {
            defaultTime = defaultTime * retry;
            retry = retry * 2;
        }
        else {
            defaultTime = 1000;
            retry = 2;
        }
        setTimeout(function () { return _this.initialize(retry); }, defaultTime);
    };
    /**
     * Handler for widget update messages
     * We update the application state with the message data
     *
     * @param {*} frame
     *
     * @memberOf App
     */
    App.prototype.onWidgetUpdate = function (frame) {
        // console.log('onWidgetUpdate', frame);
        if (frame.command === App.COMMANDS.MESSAGE) {
            hermesLog('debug', 'preparing to render', 'data received');
            this.setSubscribed(true);
            var widgetData = JSON.parse(frame.body);
            var boostTime = this.stripHours(widgetData.nextBoostTime.hours, widgetData.nextBoostTime.minutes);
            var cvl2 = widgetData.cvlConfig.cvl2;
            // console.log('Maaaaaartyyyyyyy', boostTime);
            var tierUpTime = this.stripHours(widgetData.tierUpEnd.hours, widgetData.tierUpEnd.minutes);
            var boost_on_string = sprintf(this.state.locale.Boost_on_for_next_N0_points, [
                numberSeparator(widgetData.boostRemaining, this.state.formats.GROUP_SEP, this.state.formats.DECIMAL_SEP),
            ]);
            var level_chest_upgrade = sprintf(this.state.locale.Level_N0X_N1_N2_Chests_to_upgr_ELL, [
                widgetData.tierId,
                widgetData.cvlConfig.recentBarCounter,
                widgetData.cvlConfig.tierUpBars
            ]);
            var win_chests_days = sprintf(this.state.locale.Win_N0_Chests_in_a_rolling_N1__ELL, [
                widgetData.cvlConfig.tierUpBars,
                widgetData.cvlConfig.tierUpDays
            ]);
            var you_have_completed = sprintf(this.state.locale.YouXve_completed_N0NN_of_your__ELL, [
                widgetData.cvlConfig.exchangePercent
            ]);
            var showTierUp = cvl2 ? widgetData.goingToTierUp : widgetData.showTierUp;
            var showTierDown = cvl2 ? widgetData.goingToTierDown : false;
            // .. dispatch an event if the showTierUp boolean value changes
            if (this.state.showTierUp !== widgetData.showTierUp) {
                dispatchGlobalEvent('srwrdsTierUp', {
                    showTierUp: widgetData.showTierUp,
                });
            }
            // .. dispatch an event if the chestCount value changes
            if (this.state.chestsCount !== widgetData.chestsCount ||
                this.state.optedIn !== widgetData.userOptedIn) {
                dispatchGlobalEvent('srwrdsUnopenedChests', {
                    optedIn: widgetData.userOptedIn,
                    chestsToOpen: widgetData.chestsCount,
                });
            }
            if (this.initialWidgetData) {
                // .. on login - skip the animation queue & set the initial data
                this.setWidgetData({ cvl2: cvl2, widgetData: widgetData, tierUpTime: tierUpTime, boost_on_string: boost_on_string, level_chest_upgrade: level_chest_upgrade, win_chests_days: win_chests_days, you_have_completed: you_have_completed, boostTime: boostTime, showTierUp: showTierUp, showTierDown: showTierDown });
            }
            else {
                // .. add the widget data to the animation queue
                this.addToAnimationQueue({
                    cvl2: cvl2,
                    widgetData: widgetData,
                    boostTime: boostTime,
                    showTierUp: showTierUp,
                    showTierDown: showTierDown,
                    tierUpTime: tierUpTime,
                    boost_on_string: boost_on_string,
                    level_chest_upgrade: level_chest_upgrade,
                    win_chests_days: win_chests_days,
                    you_have_completed: you_have_completed
                });
            }
        }
    };
    /**
     * Handler for the stomp client connect command
     * We subscribe to the widget topic
     *
     * @param {*} frame
     *
     * @memberOf App
     */
    App.prototype.onConnect = function (frame) {
        var _this = this;
        hermesLog('debug', 'connecting', frame.command + ' signal received');
        if (frame.command === App.COMMANDS.CONNECTED) {
            this.setAuthenticated(true);
            var subscription = this.stompClient.subscribe(App.TOPICS.WIDGET + getCookieAdapter('SBTK'), function (updateFrame) { return _this.onWidgetUpdate(updateFrame); });
            var apiSubscription = this.stompClient.subscribe(App.TOPICS.API + getCookieAdapter('SBTK'), function (updateFrame) {
                _this.exchangeResponse(JSON.parse(updateFrame.body));
            });
            this.subscriptions.push(subscription, apiSubscription);
        }
    };
    App.prototype.onError = function (frame, retry) {
        if (frame.command === App.COMMANDS.ERROR) {
            hermesLog('warn', 'WS connection error', frame.code + ' ' + frame.headers['message']);
        }
        else if (frame.code === 1001 || frame.code !== 1002) {
            hermesLog('info', 'WS connection dropped, reconnecting', frame.headers['message']);
            this.reconnect(2);
        }
        else if (retry !== undefined) {
            this.reconnect(retry);
        }
        else {
            hermesLog('warn', 'WS connection cannot be established', 'WS Error: ' + frame.code);
        }
    };
    /**
     * Builds the authentication header that is sent with the connect command
     * We read each field from cookies to build the header
     *
     * @returns {AuthHeader}
     *
     * @memberOf App
     */
    App.prototype.getAuthHeader = function () {
        var header = {
            WBID: getCookieAdapter('WBID'),
            SBTK: getCookieAdapter('SBTK'),
            SBSG: getCookieAdapter('SBSG'),
        };
        return header;
    };
    /**
     * Set state as authenticated
     * The user has an authenticated state when we sucessfully connect to the socket server with valid credentials
     *
     * @param {boolean} authenticated
     *
     * @memberOf App
     */
    App.prototype.setAuthenticated = function (authenticated) {
        this.setState({
            auth: authenticated,
        });
    };
    /**
     * Set state as subscribed
     * The app has a subscribed state when we receieve our first message from the widget topic
     *
     * @param {boolean} subscribed
     *
     * @memberOf App
     */
    App.prototype.setSubscribed = function (subscribed) {
        this.setState({
            subscribed: subscribed,
        });
    };
    /**
     * Disconnect from the web socket server
     *
     * @memberOf App
     */
    App.prototype.disconnect = function () {
        hermesLog('debug', 'disconnecting', 'Disconnect signal received');
        if (this.stompClient) {
            this.stompClient.disconnect();
        }
        this.prevLoggedIn = false;
        this.setAuthenticated(false);
        this.setSubscribed(false);
        this.clearAnimationQueue();
        this.unsubscribeAll();
    };
    /**
     * Unsubscribe to all
     * We keep track of array of subscriptions, clear them down
     *
     * @memberOf App
     */
    App.prototype.unsubscribeAll = function () {
        while (this.subscriptions.length > 0) {
            var sub = this.subscriptions.pop();
            sub.unsubscribe();
        }
    };
    App.prototype.render = function (props) {
        var _this = this;
        if (this.state.auth && this.state.subscribed) {
            if (this.state.userOptedIn) {
                // console.log('[if] userOptedIn:', this.state.userOptedIn);
                return (h(WatchClickOutside, { handleClick: this.hideDetails },
                    this.state.needsLogo ? h(SrwrdsLogo, null) : null,
                    h("div", { id: "starsrewards", className: 'srwrds-widget'
                            + (this.state.cvl2 ? ' srwrds-2' : ''), onMouseEnter: this.showDetails, onMouseDown: this.showDetailsDown, style: 'transform: scale(' + this.state.scaling + ')', onClick: function () {
                            _this.state.barOnly
                                ? dispatchGlobalEvent("showStarsRewardsExpand")
                                : null;
                        } },
                        !this.state.detailsOnly && (h(ProgressBar, { cvl2: this.state.cvl2, tierId: this.state.tierId, hideNudge: this.state.hideNudge, chestsCount: this.state.chestsCount, boostRemaining: this.state.boostRemaining, currentPoints: this.state.currentPoints, hideDropdown: this.isDropdownClosed, showTierUp: this.state.showTierUp, showTierDown: this.state.showTierDown, targetPoints: this.state.targetPoints, onMouseEnter: this.onProgressMouseEnter, onMouseClick: this.onProgressMouseClick, onMouseDown: this.onProgressMouseDown, onMouseLeave: this.onProgressMouseLeave, tierComplete: this.tierComplete, boostChange: this.boostChange, scaling: this.state.scaling, pointsUp: this.pointsUp, tierChange: this.state.tierChange, sounds: this.state.sounds })),
                        (this.state.showDropdown || this.state.isExpanded) &&
                            !this.state.barOnly ? (h(Dropdown, { currentPoints: this.state.currentPoints, targetPoints: this.state.targetPoints, tierId: this.state.tierId, boostRemaining: this.state.boostRemaining, boostOnPoints: this.state.Boost_on_for_next_N0_points, levelChestUpgrade: this.state.Level_N0X_N1_N2_Chests_to_upgr_ELL, boostTime: this.state.boostTime, noOfPoints: this.state.N0_points, noToUpgrade: this.state.N0_to_upgrade, nextBoostNumber: this.state.Next_boostX_N0, nextBoostTime: this.state.nextBoostTime, nextChestNo: this.state.Next_chestX_N0_points, showTierUp: this.state.showTierUp, chestsCount: this.state.chestsCount, openChest: this.state.Open_Chest, moreInfo: this.state.More_info, exchange: this.state.Exchange, exchangeNow: this.state.Exchange_now, cancel: this.state.Cancel, doYouWantToExchange: this.state.Do_you_want_to_exchange_your_c_ELL, clickForMoreInfo: this.state.Click_for_more_information, boostsDouble: this.state.Boosts_double_the_rate_at_whic_ELL, toWin: this.state.To_win_a_ChestX_fill_your_prog_ELL, winChests: this.state.Win_N0_Chests_in_a_rolling_N1__ELL, youHave: this.state.You_have_until_then_to_complet_ELL, youCompleted: this.state.YouXve_completed_N0NN_of_your__ELL, expires: this.state.ExpiresX, onDropdownExpanded: this.onDropdownExpanded, onMouseEnter: this.onDropdownMouseEnter, onMouseDown: this.onDropdownMouseDown, onMouseLeave: this.onDropdownMouseLeave, hideDropdown: this.hideDetails, scaling: this.state.scaling, cvl2: this.state.cvl2, boostEnabled: this.state.boostEnabled, showTierDown: this.state.showTierDown, showTierDownExchange: this.state.showTierDownExchange, canExchange: this.state.canExchange, tierUpDays: this.state.tierUpDays, tierUpBars: this.state.tierUpBars, daysToExpire: this.state.daysToExpire, exchangePercent: this.state.exchangePercent, expiresOn: this.state.expiresOn, recentBarCounter: this.state.recentBarCounter, timezone: this.state.timezone, exchangeAction: this.exchangeAction, hideExchangeView: this.state.hideExchangeView })) : ((this.isDropdownClosed = true)))));
            }
            else {
                // console.log('[else] userOptedIn:', this.state.userOptedIn);
                return (h(WatchClickOutside, { handleClick: this.hideDetails },
                    h("div", { id: "starsrewards", className: "srwrds-start" },
                        h(Start, { casino: this.state.isCasino, join: this.state.locale.Join_Stars_Rewards, label: this.state.locale.Start, nudge: this.state.optinNotificationActive }))));
            }
        }
    };
    App.WS_ENDPOINT = document
        .querySelector('[stars-rewards]')
        .getAttribute('srwrds-srv');
    App.TOPICS = {
        WIDGET: '/topic/widget/',
        API: '/topic/api/',
    };
    App.DESTINATION = {
        API: '/app/starsrewards/api'
    };
    App.COMMANDS = {
        CONNECTED: 'CONNECTED',
        MESSAGE: 'MESSAGE',
        ERROR: 'ERROR',
    };
    // private static readonly RAM_LOGIN_EVT = 'loggedIn';
    // PYR-54876 - loggedIn above to be removed after verified in production
    App.RAM_INIT_EVT = 'srwrdsInit';
    App.RAM_SHOW_EVT = 'srwrdsShow';
    App.RAM_LOGOUT_EVT = 'loggedOut';
    App.RAM_HIDE_EVT = 'srwrdsHide';
    App.SOUNDS_EVT = 'soundStarsRewards';
    App.DEFAULT_LANG = 'en';
    App.ANIMATION_DELAY = 1650;
    return App;
}(Component));
export default App;
